__turbopack_context__.v({
  "article": "FeaturedArticleHome-module-scss-module__yjcUaa__article",
  "borderless": "FeaturedArticleHome-module-scss-module__yjcUaa__borderless",
  "content": "FeaturedArticleHome-module-scss-module__yjcUaa__content",
  "content-block": "FeaturedArticleHome-module-scss-module__yjcUaa__content-block",
  "description": "FeaturedArticleHome-module-scss-module__yjcUaa__description",
  "featured-article": "FeaturedArticleHome-module-scss-module__yjcUaa__featured-article",
  "rounded": "FeaturedArticleHome-module-scss-module__yjcUaa__rounded",
  "section": "FeaturedArticleHome-module-scss-module__yjcUaa__section",
  "thumbnail": "FeaturedArticleHome-module-scss-module__yjcUaa__thumbnail",
  "thumbnail-wrapper": "FeaturedArticleHome-module-scss-module__yjcUaa__thumbnail-wrapper",
});
